import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { organizationService } from '../services/organizationService';

const TeamInviteAccept = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await organizationService.previewInvite(token);
        setPreview(res.data);
      } catch (e) {
        setError(e.response?.data?.message || e.message || 'Invalid invite');
      }
    };
    if (token) load();
  }, [token]);

  const accept = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await organizationService.acceptInvite(token, { name, password });
      alert('Invite accepted. Please log in.');
      navigate('/login');
    } catch (err) {
      alert(err.response?.data?.message || err.message || 'Failed to accept invite');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow p-8 max-w-md w-full">
        <h1 className="text-2xl font-semibold text-primary mb-2">Join team</h1>
        {error && <p className="text-red-600 text-sm">{error}</p>}
        {preview && (
          <>
            <p className="text-sm text-gray-600 mb-4">
              You are invited to <strong>{preview.organizationName}</strong> as{' '}
              <strong>{preview.role}</strong> ({preview.email}).
            </p>
            <form onSubmit={accept} className="space-y-3">
              <label className="flex flex-col gap-1 text-sm">
                Your name
                <input
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="border rounded px-3 py-2"
                />
              </label>
              <label className="flex flex-col gap-1 text-sm">
                Create password
                <input
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="border rounded px-3 py-2"
                />
              </label>
              <button
                type="submit"
                disabled={saving}
                className="w-full bg-primary text-white py-2 rounded-lg"
              >
                {saving ? 'Accepting…' : 'Accept invite'}
              </button>
            </form>
          </>
        )}
        <p className="text-xs text-center mt-4">
          <Link to="/login" className="text-primary underline">
            Back to login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default TeamInviteAccept;
